import React from "react";
import { ChevronDown } from "lucide-react";

/**
 * Native HTML <select> styled to match the premium form theme.
 * Native select is rock-solid on every mobile device (uses OS-native picker)
 * and avoids touch/portal issues from custom dropdown libraries.
 */
export default function NativeSelect({
  value,
  onChange,
  placeholder = "Select an option...",
  options = [],
  className = "",
  ...rest
}) {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
        className="premium-input h-12 w-full appearance-none rounded-md pl-3 pr-10 text-sm md:text-base text-white focus:outline-none cursor-pointer"
        style={{ colorScheme: "dark" }}
        {...rest}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt} className="bg-[#0a0c12] text-white">
            {opt}
          </option>
        ))}
      </select>
      <ChevronDown
        className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/50 pointer-events-none"
        aria-hidden
      />
    </div>
  );
}
